import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import './index.css';
import App from './App';
import './config/apiClientSetup';
import { auth0Config } from './config/auth0Config';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Auth0Provider {...auth0Config}>
      <App />
    </Auth0Provider>
  </React.StrictMode>
);
